<template>
    <div class="text-center">
        <v-dialog persistent
                v-model="$store.getters.passwordDialog"
                width="500">

            <v-card>
                <v-card-title class="white--text primary mb-2">
                    <h3 class="white--text">Αλλαγή Κωδικού</h3>
                    <v-spacer></v-spacer>
                    <v-icon @click="closeDialog" color="white">close</v-icon>
                </v-card-title>

                <v-card-text style="background-color: #87ccd9">
                    <v-form ref="passwordForm" v-model="validForm">

                        <v-row justify="center" >
                            <v-col cols="12" style="max-height: 65px" class="mt-2">
                                <v-text-field type="password" :rules="[utils.requiredRule, utils.onlyLatinCharsRule,
                                utils.atLeastOneNumberRule, utils.atLeastOneLatinUpperCaseLetterRule, utils.atLeastOneLatinLowerCaseLetterRule,
                                 utils.eightCharsLengthRule, utils.noSpacesRule, utils.atLeastOneSymbolRule ]"
                                              label="Νέος Κωδικός" outlined color="white"
                                              dense v-model="pass"/>
                            </v-col>
                        </v-row>
                        <v-row justify="center" >
                            <v-col cols="12" style="max-height: 65px">
                                <v-text-field type="password" :rules="[utils.requiredRule,passwordsMatchRule()]"
                                              label="Νέος Κωδικός(ξανά)" outlined color="white"
                                              dense v-model="reTypePass"/>
                            </v-col>
                        </v-row>
                        <v-row justify="center" >
                            <v-col cols="12" style="max-height: 65px">
                                <v-btn :disabled="!validForm" color="primary" @click="changePass">
                                   Αποθήκευση <v-icon>mdi-check-all</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import utils from "../utilities";
	import requests from "../requests";
	export default {
		name: "SetPasswordDialog",
        props:{
		    persistent: Boolean
        },
		data: () =>({
			validForm: false,
            currentPass:'',
			pass:'',
			reTypePass:''
		}),
		computed: {
			utils() {
				return utils;
			}
		},

		methods:{

            closeDialog(){
                this.$store.commit('setPasswordDialog', false);
            },

            passwordsMatchRule(){
            	if(!utils.isBlank(this.pass) && !utils.isBlank(this.reTypePass) ){
            		if(this.pass === this.reTypePass){
            			return true;
                    }else{
            			return 'Τα συνθηματικά δεν ταιριάζουν';
                    }
                }else{
					return 'Τα συνθηματικά δεν ταιριάζουν';
                }
            },
            changePass(){
				document.activeElement.blur();
				this.$store.commit('setLoadingModal', true);
                requests.put('rest/user/change-pass/' + this.pass, null, this.changePassCallBack)
            },

			changePassCallBack(){
				this.$store.commit('setLoadingModal', false);
				this.$store.commit('setPasswordDialog', false);
            },
		},

        watch:{
            '$store.getters.passwordDialog': function(val) {
                if(this.$refs.passwordForm) {
                    this.$refs.passwordForm.resetValidation();
                }
                this.currentPass = '';
                this.pass = '';
                this.reTypePass = '';
            }
        },


    }
</script>

<style scoped>

</style>